<template>
  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" v-bind:class="{ 'form-error': !isValid(item) }" id="button-addon1">{{ id }}</span>
    </div>
    <input
      type="text"
      v-bind:value="type"
      v-on:change="change"
      placeholder="New bulk type"
      class="form-control"
      aria-label="Example text with button addon"
      aria-describedby="button-addon1"
    />
    <a
      class="btn btn-danger ml-1"
      style="padding: 5px"
      
      @click="deleteType"
    >
    <i class="far fa-trash-alt"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: "BulkTypeLabelEditor",
  props: {
    id: Number,
    type: String,
    change: Function,
    deleteType: Function,
    item: Object,
    msg: String,
    pickup: String,
  },
  methods: {
    isValid(item) {
       
      if((item.name == "" || item.name == null) && this.type == "") {
          return false;
      }

      if((item.pickup == "" || item.pickup == null)  && this.pickup == "") {
          return false;
      }
      if((item.message == "" || item.message == null) && this.msg == "") {
          return false;
      }
      return true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>